import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {UserService} from "../../../../../user/user.service";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {Utils} from "../../../../../shared/utils/utils";
import {DbValidators} from "../../../../../shared/validators/DbValidators";
import {CookieService} from "ngx-cookie";
import {DbServerErrors} from "../../../../../shared/interceptors/db-server-errors";
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {AuthService} from "../../../../../auth/auth.service";
import {TypeUtils} from "../../../../../shared/utils/type-utils";
import {Config} from "../../../../../config/config";
import {ReCaptchaV3Service} from "ngx-captcha";
import {filter, first} from "rxjs/operators";
import {UserSubscription} from "../../../../../user/user-subscription";
import {CompanyInfo} from "../../../../../store/actions/company-info.action";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../store';
import testimonialsList from "../../../../../../assets/json/testimonials.json";
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";
import {BuilderSectionsInteractionService} from "../../../../../builder-v2/builder-sections-interaction.service";
import {NgIf} from "@angular/common";
import {
  LoadingCircularSpinnerComponent
} from "../../../../../shared/components/loading-circular-spinner/loading-circular-spinner.component";
import {CheckoutService} from "../../../../../auth/checkout/checkout.service";
import {GoogleAuthComponent} from "../../../../../auth/google-auth/google-auth.component";
import {GlobalEvent} from "../../../../../shared/services/global-event-dispatcher/global-event";
import {
  GlobalEventDispatcherService
} from "../../../../../shared/services/global-event-dispatcher/global-event-dispatcher.service";
import {BuilderHistoryService} from "../../../../builder-history.service";

@Component({
    selector: 'db-mobile-sign-up',
    templateUrl: './mobile-sign-up.component.html',
    styleUrls: ['./mobile-sign-up.component.scss'],
    imports: [
        NgIf,
        ReactiveFormsModule,
        LoadingCircularSpinnerComponent,
        GoogleAuthComponent,
    ]
})
export class MobileSignUpComponent implements OnInit, OnDestroy {

  @Input() params: Record<string, string | number> = {};
  @Input() forSetup: boolean = false;
  @Input() fromEcommerce: boolean;
  @Input() v2Data: any;
  @Input() uniqueId: string;

  prefilledAi: boolean = false;
  public isMobile: boolean = false;
  public loading: boolean;
  public googleBtnLoading: boolean;
  public emailBtnLoading: boolean;
  public enableRecaptcha: boolean;
  public serverErrors: DbServerErrors;
  public signUpForm: FormGroup;
  public subscription: UserSubscription;
  public answersData;
  public people: any = testimonialsList;
  public userLocalStorage: any = {};
  public progress: number = 0;
  public showPassword: boolean = false;
  public formSubmitted: boolean = false;
  public hasServerFieldErrors: boolean;
  public showPWDRequirements: boolean = false;
  public googleSignUpFormSubmitted: boolean;
  public productId: number;
  public companyInfo: CompanyInfo;

  constructor(
    private _cookieService: CookieService,
    private _authService: AuthService,
    private _userService: UserService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _activeModal: DbActiveModal,
    private _reCaptchaV3Service: ReCaptchaV3Service,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _store: Store<fromStore.DbStoreState>,
    private _builderInteractionsService: BuilderSectionsInteractionService,
    private _builderHistoryService: BuilderHistoryService,
    private _checkoutService: CheckoutService,
    private _globalEventDispatcher: GlobalEventDispatcherService
  ) {
    const navigation = this._router.getCurrentNavigation();
    this.fromEcommerce = this._builderInteractionsService.getWebsiteTypeMobile() === 'ecommerce' || this._builderInteractionsService.websiteType.value === 'ecommerce';
    this.uniqueId = this._builderHistoryService.getUniqueId();
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 991;
    this.prefilledAi = !!localStorage.getItem('prefilledAiData');
    if (this.isMobile) {
      this._builderInteractionsService.setBackAction(() => {
        const data = this._builderHistoryService.getFormData();
        this._builderHistoryService.saveFormData(data);
        this._router.navigate(this.fromEcommerce ? [`../fill-products`] : [this.prefilledAi ? `../filled-company-info` : `../fill-company-info`], {relativeTo: this._route});
      });
    }
    if (localStorage.getItem('product_id')) {
      this.productId = parseInt(localStorage.getItem('product_id'), 10);
    }
    this.signUpForm = new FormGroup({
      'firstName': new FormControl('', [
        Validators.required,
        Utils.patternValidator(/[-a-zA-Z0-9@:%_+.~#?&\/=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_+.~#?&\/=]*)?/, {link: true}, true)
      ]),
      'lastName': new FormControl('', [
        Validators.required,
        Utils.patternValidator(/[-a-zA-Z0-9@:%_+.~#?&\/=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_+.~#?&\/=]*)?/, {link: true}, true)
      ]),
      'email': new FormControl('', [DbValidators.trim, Validators.required, Validators.email, Validators.pattern(/^[+_\-a-zA-Z0-9]+(\.[+_\-a-zA-Z0-9]+)*@[+_\-a-zA-Z0-9]+(\.[+_\-A-Za-z0-9]+)*(\.[+_\-A-Za-z]{2,24})$/)]),
      'password': new FormControl('',
        [Validators.required, Validators.minLength(8), DbValidators.trim,
          Utils.patternValidator(/\d/, {hasNumber: true}),
          Utils.patternValidator(/[A-Z]/, {hasCapitalCase: true}),
          Utils.patternValidator(/[a-z]/, {hasSmallCase: true})
        ]),
      /*'signUpFor': new FormControl(null, Validators.required),*/
      'subscriptionId': new FormControl(Config.basePlanId),
      'affiliate_id': new FormControl(this._cookieService.get('_fprom_track') || this._cookieService.get('idev')),
      'paymentMethod': new FormControl('stripe'),
      'plugin_id': new FormControl('')
    });
    this._sendGaEvent('pop-up opened');
    this._setAnswersData();
    this.recaptchaMode();
    this._store.select(fromStore.getCompanyInfo).pipe(filter(info => !!info), first()).subscribe(info => {
      this.companyInfo = info;
    });
  }

  public recaptchaMode(): void {
    this._authService.recaptchaEnv()
      .pipe(filter((response: DbResponse): boolean => !!response),
        first())
      .subscribe((response) => {
        if (response.success) {
          this.enableRecaptcha = response.data.recaptcha_mode.value === 'live';
        }
      });
  }

  public signUpWithGoogle(googleToken): void {
    this.googleSignUpFormSubmitted = true;
    this.googleBtnLoading = true;
    localStorage.setItem('loadingGoogle', "1");
    localStorage.setItem('dbAnswersData', JSON.stringify(this.answersData));
    if (!this.forSetup) {
      !TypeUtils.isEmpty(this.params) && localStorage.setItem('dbStartAiParams', JSON.stringify(this.params));
      !!this.v2Data && localStorage.setItem('dbShowV2Finalize', '1');
    }
    this._sendGaEvent('Signup button click - Google');
    this._checkoutService.verifyGoogleToken(googleToken, this.signUpForm.controls['subscriptionId'].value, null, this.productId, null, this.signUpForm.controls['affiliate_id'].value, null)
      .pipe(filter((response: DbResponse): boolean => !!response),
        first())
      .subscribe((response) => {
        if (response.success) {
          if (response.data && !response.data.agreement) {
            this._activeModal.close('existing');
            this._router.navigate(['/websites'], {
              queryParams: {
                forceCreateWebsite: true,
                fromGoogleSignIn: true,
                fromSignup: 1,
              }
            });
          } else {
            this.updateSignUpForData();
            this._userService.setToLocal({createdAfterUM: true});
            if (!this.forSetup) {
              this.proceedToNextQuestion();
            }
          }
          this.googleBtnLoading = false;
          this._globalEventDispatcher.dispatchEvent(GlobalEvent.userLogIn);
          this._store.dispatch(new fromStore.UserLogIn);
        } else {
          if (response.serverErrors && response.serverErrors.message !== "Client is not verified") {
            this.serverErrors = response.serverErrors;
            this.checkHasServerFieldErrors(response.serverErrors);
          }
          this.googleBtnLoading = false;
        }
      });
    /*this._authService.proceedWithGoogle(this.signUpForm.controls['subscriptionId'].value, false, this.productId, null, this.signUpForm.controls['affiliate_id'].value, null);*/
  }

  signUpWithEmail() {
    this._router.navigate(['../mobile-sign-up-email'], {
      queryParams: {websiteType: this.fromEcommerce ? 'ecommerce' : 'business'},
      relativeTo: this._route
    });
  }

  public progressPercent(): void {
    this.progress = Utils.progressPercent(this.signUpForm.controls['password']);
  }

  public proceedToNextQuestion(): void {
    localStorage.removeItem('prefilledAiData');
    this._router.navigate(['/setup/builder-v2'], {
      queryParams: {
        showFinalize: true,
        websiteType: this.fromEcommerce ? 'ecommerce' : 'business'
      }
    });
  }

  ngOnDestroy() {
    // this._handleUnload();
  }

  private _setAnswersData(): void {
    this.answersData = {};
    this.answersData.Role = {
      "answer": "SMB",
      "id": "eLLnqwOWEyzs"
    };
    this.answersData.WebsiteNumber = {
      "answer": "1-3",
      "id": "EQ6sqoPuMvGg"
    };
    if (!this.forSetup) {
      if (this.productId === Config.builder2PluginId) {
        this.answersData.LastChosenOption = {
          "answer": "ai-demo-section",
          "id": ""
        };
      } else if (this.productId === Config.builder2HostedPluginId) {
        this.answersData.LastChosenOption = {
          "answer": "ai-hosted-section",
          "id": ""
        }
      }
      else if (this.productId === Config.vibeCodingPluginId) {
        this.answersData.LastChosenOption = {
          "answer": "ai-hosted-vibe",
          "id": ""
        }
      }
      else {
        this.answersData.LastChosenOption = {
          "answer": "ai-demo-template",
          "id": ""
        };
      }

      this.answersData.Action = {
        "answer": "skip",
        "id": ""
      };
    } else if (this.productId === Config.aiCreateWebsitePluginId) {
      this.answersData.LastChosenOption = {
        "answer": "ai-convert",
        "id": ""
      };
    } else if (this.productId === Number(Config.managerPluginId)) {
      this.answersData.LastChosenOption = {
        "answer": "change-hosting",
        "id": ""
      };
    } else if (this.productId === Number(Config.installBlankPluginId)) {
      this.answersData.LastChosenOption = {
        "answer": "install-blank",
        "id": ""
      };
    }
  }

  private updateSignUpForData(): void {
    this._authService.updateSignUpFor(this.answersData, true)
      .pipe(
        first(response => !!response, null),
      )
      .subscribe(() => {
        this.updateUserLocalStorage();
      });
  }

  private updateUserLocalStorage(): void {

    this.loading = true;
    this.userLocalStorage['signUpFor'] = this.answersData;
    this._userService.setToLocal(this.userLocalStorage);
    if (!!this.forSetup) {
      this._redirectToOptions();
    }
  }

  private _redirectToOptions(): void {
    if (this.productId === Config.aiCreateWebsitePluginId) {
      localStorage.setItem('dbFromSetup', '1');
      setTimeout(() => {
        this.navigateTo('/setup/ai-convert');
      }, 1000);
    } else if (this.productId === Config.managerPluginId) {
      localStorage.setItem('dbFromMigrate', '1');
      setTimeout(() => {
        this.navigateTo('/setup/change-hosting');
      }, 1000);
    } else if (this.productId === Config.installBlankPluginId) {
      localStorage.setItem('dbFromBlank', '1');
      setTimeout(() => {
        this.navigateTo('/setup/install-blank');
      }, 1000);
    }
  }

  private navigateTo(url: string): void {
    this.loading = false;
    this._router.navigateByUrl(url).then((success) => {
      if (success) {
        this._activeModal.close();
      }
    });
  }

  private checkHasServerFieldErrors(serverErrors: DbServerErrors): void {
    this.hasServerFieldErrors = serverErrors && !!Utils.intersect(Object.keys(serverErrors.fields), ['name', 'first_name', 'last_name', 'email', 'password', 'stripe_token']).length;
  }

  private _sendGaEvent(label): void {
    const analyticsData = {
      eventCategory: 'Onboarding',
      eventAction: 'Sign-up form',
      eventLabel: label,
      isMobile: this.isMobile
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCoreWithoutUserData(analyticsData);
  }

}
